import { useRouter } from 'next/router';
import { useMemo } from 'react';

interface DisplayConditionsProps {
  internalPlayer: boolean;
  playerReady: boolean;
  isAdBreak: boolean;
  playbackMode: string;
  contentState: string;
  subtitleCues: {
    startTime: number;
    endTime: number;
    text: string;
  }[];
}

export function useDisplayConditions({
  internalPlayer,
  playerReady,
  isAdBreak,
  playbackMode,
  contentState,
  subtitleCues
}: DisplayConditionsProps) {
  const router = useRouter();

  const displayControls = useMemo(
    () =>
      internalPlayer &&
      playerReady &&
      !isAdBreak &&
      playbackMode !== 'unstarted' &&
      playbackMode !== 'ended',
    [internalPlayer, playerReady, isAdBreak, contentState, playbackMode]
  );

  const displaySubtitles = useMemo(
    () => router.query.subtitle && subtitleCues.length > 0 && !isAdBreak,
    [router.query.subtitle, subtitleCues, isAdBreak]
  ) as boolean | undefined;

  return {
    displayControls,
    displaySubtitles
  };
}
